import {PublicWrapper} from '../../modules/common/components/PublicWrapper'
import {GoriSignatureVerify} from '../../modules/gori-signature'

export default function GoriSignatureVerifyWrapper() {
  return (
    <PublicWrapper>
      <GoriSignatureVerify />
    </PublicWrapper>
  )
}
